var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageNg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_24532",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24532",
    transform: "translate(-96.5 -95)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_13641",
    "data-name": "\\u9577\\u65B9\\u5F62 13641",
    width: 180,
    height: 180,
    rx: 90,
    transform: "translate(97.5 96)",
    fill: "none",
    stroke: "#a59785",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "concierge_FILL0_wght400_GRAD0_opsz24_2_",
    "data-name": "concierge_FILL0_wght400_GRAD0_opsz24 (2)",
    d: "M72.727-825.455v-7.273H120v7.273Zm3.636-10.909A19.344,19.344,0,0,1,81-849.227,19.37,19.37,0,0,1,92.727-856v-2.273a3.518,3.518,0,0,1,1.045-2.591,3.519,3.519,0,0,1,2.591-1.045,3.519,3.519,0,0,1,2.591,1.045A3.518,3.518,0,0,1,100-858.273V-856a19.517,19.517,0,0,1,11.682,6.773,19.231,19.231,0,0,1,4.682,12.864Zm9.545-7.364h20.727a13.18,13.18,0,0,0-4.409-3.955,11.81,11.81,0,0,0-5.864-1.5,12.244,12.244,0,0,0-6,1.5A13.048,13.048,0,0,0,85.909-843.727ZM96.273-843.727ZM40-858.182v-40H61.818v5.273L87.273-900l29.091,9.091v3.636a10.52,10.52,0,0,1-3.182,7.727,10.52,10.52,0,0,1-7.727,3.182H98.182v2.182a7,7,0,0,1-1.318,4.136,7.4,7.4,0,0,1-3.409,2.682l-24.545,9.182Zm7.273-7.273h7.273v-25.455H47.273Zm14.545,0h5.818l21.091-7.727a3.207,3.207,0,0,0,1.591-1.227,3.381,3.381,0,0,0,.591-1.955H84.455l-10.636,3.455-2.182-6.909L83-883.636h22.455a4.964,4.964,0,0,0,2.045-.591q1.227-.591,1.227-1.409l-21.636-6.727-25.273,6.909Z",
    transform: "translate(108 1049)",
    fill: "#a59785"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNg);
export default __webpack_public_path__ + "static/media/image_ng.20a8743704bdca3f350362a11ebf5f98.svg";
export { ForwardRef as ReactComponent };